import {saveAs} from 'file-saver';

// tslint:disable-next-line:no-any
export function saveAsJSONFile(fileName: string, jsonObject: any): void {
  const blob = new Blob( [JSON.stringify(jsonObject) ], {type: 'application/json;charset=utf-8'});
  saveAs(blob, fileName);
}
